import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../../util/assets';
import { getAccountMarketingMaterialSocialPrintTemplateComponent } from './helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    logo_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
};

const AccountMarketingMaterialSocialPrintTemplate = ({
  albumFolder,
  account,
}) => {
  const Template = getAccountMarketingMaterialSocialPrintTemplateComponent({
    albumFolder,
  });
  const logoUrl = account?.logo_image?.url;

  return (
    <Fragment>
      {logoUrl && (
        <div className="marketing-material-social-account-logo">
          <img
            src={logoUrl}
            alt=""
            className="marketing-material-social-account-logo-image"
          />
        </div>
      )}

      <Template albumFolder={albumFolder} account={account} />

      {albumFolder?.picture_day_enabled && (
        <img
          src={getAsset(
            '/marketing-material/MARKETING_SOCIAL_SELL_PHOTOS_TEMPLATE_1.png',
          )}
          alt=""
        />
      )}
      {!albumFolder?.picture_day_enabled && (
        <img
          src={getAsset('/marketing-material/MARKETING_SOCIAL_TEMPLATE_1.png')}
          alt=""
        />
      )}
    </Fragment>
  );
};

AccountMarketingMaterialSocialPrintTemplate.propTypes = propTypes;

export default AccountMarketingMaterialSocialPrintTemplate;
